export default __webpack_public_path__ + "static/media/1_2.627a0096.png";